import {
  Feedback,
  SET_FEEDBACK_LIST,
  FeedbackActionType,
  AppThunk,
} from '../types';
import ApiClient from '../../loopback/apiClient';

const setFeedbackList = (payload: Feedback[]): FeedbackActionType => ({
  type: SET_FEEDBACK_LIST,
  payload,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchFeedbacks = (
  surveyId?: number, digitalSurveyId?: number,
): AppThunk => async (dispatch): Promise<void> => {
  let feedbacks = [] as Feedback[];
  if (surveyId) {
    feedbacks = await ApiClient.getSurveyFeedbacks(surveyId);
  } else if (digitalSurveyId) {
    feedbacks = await ApiClient.getSurveyFeedbacksV2(digitalSurveyId);
  }
  dispatch(setFeedbackList(feedbacks));
};
